export var KevelTemplateType;
(function (KevelTemplateType) {
    KevelTemplateType["Leadgen"] = "leadgen";
    KevelTemplateType["Video"] = "video";
    KevelTemplateType["BasicHtml"] = "basic_html";
    KevelTemplateType["BasicHtmlButton"] = "basic_html_button";
    KevelTemplateType["BasicHtmlSingleImage"] = "basic_html_single_image";
    KevelTemplateType["BasicHtmlCenterImage"] = "basic_html_center_image";
    KevelTemplateType["IURecentArticle"] = "iu_recent_article";
    KevelTemplateType["BasicArticleTextAd"] = "basic_article_text_ad";
    KevelTemplateType["BasicHtmlArticleTile"] = "basic_html_article_tile";
    KevelTemplateType["VideoAndTranscript"] = "video_and_transcript";
})(KevelTemplateType || (KevelTemplateType = {}));
export var KevelNativeTemplateType;
(function (KevelNativeTemplateType) {
    KevelNativeTemplateType["ExternalImage"] = "external-image";
})(KevelNativeTemplateType || (KevelNativeTemplateType = {}));
const isRecord = (value) => {
    return typeof value === 'object' && value !== null;
};
export const isKevelTemplateType = (value) => {
    return Object.values(KevelTemplateType).includes(value);
};
export const isKevelNativeTemplateType = (value) => {
    return Object.values(KevelNativeTemplateType).includes(value);
};
export const isKevelKnownTemplateData = (value) => {
    return isRecord(value) && isKevelTemplateType(value.ct_type);
};
export const isExternalImageData = (value) => {
    return isRecord(value);
};
export const normalizeKevelDecision = (decision) => {
    const content = decision.contents[0];
    if (!content)
        return null;
    const { data } = content;
    if (isKevelKnownTemplateData(data)) {
        return {
            kind: 'custom-template',
            type: data.ct_type,
            data,
            clickUrl: decision.clickUrl,
            impressionUrl: decision.impressionUrl,
            events: decision.events
        };
    }
    if (content.template === KevelNativeTemplateType.ExternalImage &&
        isExternalImageData(data)) {
        return {
            kind: 'native-template',
            type: KevelNativeTemplateType.ExternalImage,
            data,
            clickUrl: decision.clickUrl,
            impressionUrl: decision.impressionUrl,
            events: decision.events
        };
    }
    return null;
};
//# sourceMappingURL=index.js.map